import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const PageTransitionContext = createContext();

export const usePageTransition = () => {
  const context = useContext(PageTransitionContext);
  if (!context) {
    throw new Error('usePageTransition must be used within PageTransitionProvider');
  }
  return context;
};

export function PageTransitionProvider({ children }) {
  const [isExiting, setIsExiting] = useState(false);

  // Démarre à false : pas de rideau au 1er chargement (refresh).
  // Le rideau est déclenché UNIQUEMENT par navigateWithTransition.
  const [isEntering, setIsEntering] = useState(false);

  const navigate = useNavigate();

  const navigateWithTransition = useCallback((to) => {
    if (isExiting) return;

    setIsExiting(true);

    // 500ms = durée animation de sortie
    setTimeout(() => {
      navigate(to);
      setIsExiting(false);
      setIsEntering(true);

      // 600ms = durée du rideau d'entrée (voir PageTransition.css)
      setTimeout(() => {
        setIsEntering(false);
      }, 600);
    }, 500);
  }, [navigate, isExiting]);

  return (
    <PageTransitionContext.Provider value={{
      isExiting,
      isEntering,
      navigateWithTransition
    }}>
      {children}
    </PageTransitionContext.Provider>
  );
}